import React from 'react';
import { connect } from 'react-redux';
import { fetchSinglePage, clearSinglePage } from '../../../actions/singlePage.actions';
import { fetchSingleTemplate, clearSingleTemplate } from '../../../actions/templates.actions';
import Publish from '../../viewers/publish/Publish';
import './View.css';

const View = () => {
    return (
        <div className="preview">
            <Publish />
        </div>
    );
};

const mapStateToProps = state => ({
    i18n: state.i18n,
    page: state.page.page,
    template: state.templates.template
});
const mapDispatchToProps = {
    fetchSinglePage,
    fetchSingleTemplate,
    clearSinglePage,
    clearSingleTemplate
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(View);
